<div class="context-component-wrapper" [ngStyle]="{'max-width.px': maxWidth}">
  <div class="num-wrapper">
    <div>{{selected.length}}</div>
    <div class="label-num">{{data.name | translate}}</div>
  </div>
  <div class="buttons-menu">
    @for (opt of data.options; track opt) {
      <div class="button-action" [ngClass]="{'disable': selected.length <= 0 || opt?.disabled}">
        @if (opt) {
          <a mat-icon-button (click)="selected.length <= 0 ? null : bulkAction(opt)">
            <span class="material-icons filter-btn" [class]="opt.class">{{opt.icon}}</span>
          </a>
          <span>{{opt.name | translate | mexTranslate: project}}</span>
        }
      </div>
    }
  </div>
  <div class="wrapper-close" (click)="close()">
    <span class="material-icons filter-btn">close</span>
  </div>
</div>